<template>
  <FieldBox class="main-order-type" :title="$t('trade.type')">
    <SelectBox
      v-model="orderType"
      :disabled="disabled"
      class="order-type"
      :options="orderTypes"
    />
    <div v-if="hint" class="order-hint" @click.prevent="openOrderTypeDialog">
      <span>{{ hint.label }}</span>
    </div>
  </FieldBox>
</template>
<script>
import { mapGetters } from 'vuex'
import SelectBox from 'com/SelectBox'
import Modal from 'com/Modal'
import { ORDER_TYPE } from 'const/trade'
import FieldBox from '../FieldBox'

export default {
  name: 'OrderTypeField',
  components: {
    FieldBox,
    SelectBox
  },
  props: {
    contract: Object
  },
  data() {
    return {
      showOrderTypeDialog: false
    }
  },
  computed: {
    ...mapGetters([
      'tradeRequest',
      'isIb',
      'isVirtual',
      'usMarketOpen',
      'isMarsco'
    ]),
    order() {
      return this.tradeRequest.order
    },
    stock() {
      return this.tradeRequest.stock
    },
    disabled() {
      if (this.isIb) {
        // 附加订单以及有附加订单的主订单不可修改
        return (
          !!this.order.parentId ||
          !!this.order.stopLossOrderId ||
          !!this.order.profitTakerOrderId
        )
      }
      // Omnibus 和 模拟账户不支持修改
      return this.tradeRequest.isModify
    },
    orderTypes() {
      const ORDER_LANGKEY_MAP = {
        [ORDER_TYPE.LMT]: 'trade.LMT',
        [ORDER_TYPE.MKT]: 'trade.MKT',
        [ORDER_TYPE.STP]: 'trade.STP',
        [ORDER_TYPE.STP_LMT]: 'trade.STP_LMT'
      }
      const orderTypes = this.availableOrderTypes.reduce((acc, type) => {
        // 跟踪单支持百分比和价差模式
        if (type === ORDER_TYPE.TRAIL) {
          acc.push(
            { text: this.$t('trade.TRAIL_1'), val: ORDER_TYPE.TRAIL_1 },
            { text: this.$t('trade.TRAIL_2'), val: ORDER_TYPE.TRAIL_2 }
          )
        }
        if (ORDER_LANGKEY_MAP[type]) {
          acc.push({ text: this.$t(ORDER_LANGKEY_MAP[type]), val: type })
        }
        return acc
      }, [])

      if (this.canModifiedTypes) {
        return orderTypes.filter(t => this.canModifiedTypes.includes(t.val))
      }
      return orderTypes
    },
    canModifiedTypes() {
      if (this.isIb && this.tradeRequest.isModify) {
        if ([ORDER_TYPE.LMT, ORDER_TYPE.MKT].includes(this.order.orderType)) {
          return [ORDER_TYPE.LMT, ORDER_TYPE.MKT]
        }
        if (this.orderType === ORDER_TYPE.STP) {
          return [ORDER_TYPE.STP, ORDER_TYPE.MKT]
        }
        if (this.orderType === ORDER_TYPE.STP_LMT) {
          return [ORDER_TYPE.LMT, ORDER_TYPE.STP_LMT]
        }
        if ([ORDER_TYPE.TRAIL_1, ORDER_TYPE.TRAIL_2].includes(this.orderType)) {
          return [ORDER_TYPE.TRAIL_1, ORDER_TYPE.TRAIL_2]
        }
      }
    },
    availableOrderTypes() {
      return this.contract ? this.contract.availableOrderTypes : []
    },
    orderType: {
      get() {
        return this.order.orderType
      },
      // 切换订单类型的时候需要重置一部分数据
      set(orderType) {
        this.$store.dispatch('updateTradeOrder', { orderType })
      }
    },
    hint() {
      if (this.orderType === ORDER_TYPE.STP) {
        return {
          label: this.$t('trade.order-stp-hint'),
          title: this.$t('trade.STP'),
          desc: this.$t('trade.order-stp-desc')
        }
      }
      if (this.orderType === ORDER_TYPE.STP_LMT) {
        return {
          label: this.$t('trade.order-stp-lmt-hint'),
          title: this.$t('trade.STP_LMT'),
          desc: this.$t('trade.order-stp-lmt-desc')
        }
      }
    }
  },
  mounted() {
    if (this.orderTypes.find(t => t.val === this.orderType)) return
    if (this.orderTypes[0]) this.orderType = this.orderTypes[0].val
  },
  methods: {
    openOrderTypeDialog() {
      Modal.open({
        title: this.hint.title,
        content: this.hint.desc,
        style: { textAlign: 'left' },
        cancelButton: false
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import '~uikit';

.order-hint {
  margin: 8px 0;
  color: var(--sub-text-color);
  cursor: pointer;
}
.order-hint span {
  border-bottom: 1px solid var(--border-color);
}
.hint-desc {
  white-space: pre-line;
  color: var(--sub-text-color);
}
.tt-select-box {
  width: 100%;
}
</style>
